<template>
  <div style="background-color: white">
    <el-row style="padding-top: 10px">
      <el-col :span="24">
        <el-button
          size="small"
          class="btn"
          type="primary"
          v-if="show.drsq"
          @click="handleCreate2"
          >调入申请</el-button
        >
        <!-- <el-button size="small" class="btn" type="primary" v-if="show.dcsq" @click="handleCreate1">设置闲置状态</el-button> -->
        <el-button
          size="small"
          class="btn"
          type="primary"
          v-if="show.sbdb"
          @click="handleCreate"
          >设备调拨</el-button
        >
        <el-button
          size="small"
          type="primary"
          class="btn"
          v-if="show.dctz"
          @click="derive"
          >导出列表</el-button
        >
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-form
          :inline="true"
          ref="deviceInfo"
          :model="deviceInfo"
          class="demo-form-inline"
          style="float: right !important"
        >
          <el-form-item :label="lable.drdw">
            <el-cascader
              v-model="deviceInfo.transferIn"
              style="width: 140px"
              :options="options"
              :props="companyProps"
              clearable
              :show-all-levels="false"
              filterable
              :placeholder="'请选择' + lable.drdw"
            ></el-cascader>
          </el-form-item>
          <el-form-item :label="lable.dcdw">
            <el-cascader
              v-model="deviceInfo.transferOut"
              style="width: 140px"
              :options="options"
              :props="companyProps"
              clearable
              :show-all-levels="false"
              filterable
              :placeholder="'请选择' + lable.drdw"
            ></el-cascader>
          </el-form-item>
          <el-form-item :label="lable.statue">
            <el-select
              v-model="deviceInfo.state"
              clearable
              :placeholder="'请选择' + lable.statue"
              style="width: 120px"
            >
              <el-option
                v-for="item in options3"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期">
            <el-date-picker
              v-model="deviceInfo.date"
              value-format="yyyy-MM-dd"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="模糊搜索">
            <el-input
              v-model="deviceInfo.content"
              auto-complete="off"
              placeholder="请输入搜索内容"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="findAllClick"
              >查询</el-button
            >
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table
          :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
          :cell-style="{ textAlign: 'center' }"
          :data="allocationData"
          :row-key="getRowKeys"
          ref="allocationData"
          @selection-change="changeCheckBoxValue"
          tooltip-effect="dark"
          style="width: 100%; text-align: center"
          stripe
        >
          <el-table-column
            type="selection"
            :reserve-selection="true"
            width="55"
          >
          </el-table-column>
          <el-table-column prop="id" :label="lable.id" width="170">
            <template slot-scope="scope" show-overflow-tooltip>
              <el-link
                :underline="false"
                @click="selectClick(scope.row)"
                style="color: #4095e5; text-decoration: none"
              >
                {{ scope.row.id }}
              </el-link>
            </template>
          </el-table-column>
          <el-table-column
            prop="sqrq"
            :formatter="formateTime"
            :label="lable.sqrq"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="drdw"
            :label="lable.drdw"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="dcdw"
            :label="lable.dcdw"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="userName"
            :label="lable.userName"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="dbly"
            :label="lable.dbly"
            show-overflow-tooltip
          >
          </el-table-column>

          <el-table-column
            prop="statue"
            :label="lable.statue"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              <span v-if="scope.row.statue == '4'" style="color: #4095e5"
                >待审核</span
              >
              <span
                v-else-if="scope.row.statue == '2'"
                style="color: rgb(204, 169, 13)"
                >撤回</span
              >
              <span
                v-else-if="scope.row.statue == '6'"
                style="color: mediumturquoise"
                >待确认</span
              >
              <span v-else-if="scope.row.statue == '5'" style="color: coral"
                >待调拨</span
              >
              <span v-else-if="scope.row.statue == '7'" style="color: gray"
                >待调出确认</span
              >
              <span v-else-if="scope.row.statue == '8'" style="color: gray"
                >待调入确认</span
              >
              <span
                v-else-if="scope.row.statue == '9'"
                style="color: yellowgreen"
                >调拨完成</span
              >
              <span v-else-if="scope.row.statue == '0'" style="color: red"
                >驳回</span
              >
            </template>
          </el-table-column>
          <el-table-column :label="lable.cz" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-button
                @click="updateClick(scope.row)"
                v-if="
                  (scope.row.statue == '0' || scope.row.statue == '2') &&
                  show.xg &&
                  scope.row.sqr == userinfo.id
                "
                type="text"
                size="small"
                >更改</el-button
              >
              <el-button
                v-if="
                  (scope.row.statue == '0' || scope.row.statue == '2') &&
                  show.sc &&
                  scope.row.sqr == userinfo.id
                "
                @click="delAllocation(scope.row)"
                type="text"
                size="small"
                >删除</el-button
              >
              <el-button
                v-if="scope.row.statue == '7' && show.dbch"
                @click="withdrawClick(scope.row)"
                type="text"
                size="small"
                >调拨撤回</el-button
              >
              <el-button
                v-if="scope.row.statue == '4' && show.ch"
                @click="clickApplyWithdraw(scope.row)"
                type="text"
                size="small"
                >申请撤回</el-button
              >
              <el-button
                @click="selectClick(scope.row)"
                type="text"
                size="small"
                >详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <!--分页工具条-->
      <el-col :span="24" class="toolbar" style="margin-top: 5px; height: 35px">
        <el-pagination
          v-if="allocationData.length > 0"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pagesize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="float: right"
        >
        </el-pagination>
      </el-col>
    </el-row>
    <!--------------------------------------------------------------------设备调拨弹框--------------------------------------------------------------------------------->
    <el-dialog
      :visible.sync="dialogFormVisible"
      title="设备调拨"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      style="width: 100% !important; margin-left: 80px"
    >
      <el-form
        :model="questionForm"
        ref="dataForm"
        label-position="left"
        label-width="100px"
        style="width: 90%; margin-left: 5%"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.drdw">
              <el-cascader
                v-model="questionForm.drdw"
                style="width: 100%"
                :options="options"
                :props="props1"
                clearable
                :show-all-levels="true"
                filterable
                :placeholder="'请选择' + lable.drdw"
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="lable.dbly" prop="dbly">
          <el-input
            type="textarea"
            :rows="2"
            :placeholder="'请输入' + lable.dbly"
            v-model="questionForm.dbly"
          />
        </el-form-item>
        <el-form-item label="资产列表">
          <el-table
            :data="assetsData"
            :border="true"
            style="width: 100%; text-align: center"
            size="mini"
            max-height="235px"
            :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
            :cell-style="{ textAlign: 'center' }"
          >
            <el-table-column prop="glbh" label="管理编号" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="zcbh" label="资产编号" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="zcmc" label="资产名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="id" v-if="false"> </el-table-column>
            <el-table-column prop="sbxh" label="规格型号" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="ssdw" label="所属单位" show-overflow-tooltip>
            </el-table-column>
            <el-table-column fixed="right" label="操作" show-overflow-tooltip>
              <template slot="header" slot-scope="scope">
                <DC :transferValue="transferValue" :personInfo="0"></DC>
              </template>
              <template slot-scope="scope">
                <el-button @click="handleClick(scope.row)" type="text"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="附加资料" prop="dbly">
          <el-table
            :data="fileData"
            :border="true"
            style="width: 100%; text-align: center"
            size="mini"
            max-height="235px"
            :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
            :cell-style="{ textAlign: 'center' }"
          >
            <el-table-column label="序号" type="index" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="name" label="资料名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="id" v-if="false"> </el-table-column>
            <el-table-column
              prop="createTime"
              label="上传日期"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column prop="fileDesc" label="备注" show-overflow-tooltip>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="200px">
              <template slot="header" slot-scope="scope">
                <el-button
                  type="text"
                  @click="innerVisible = true"
                  icon="el-icon-plus"
                  >增加
                </el-button>
              </template>
              <template slot-scope="scope">
                <el-button
                  @click="handleClick(scope.row)"
                  type="text"
                  size="small"
                  >编辑</el-button
                >
                <el-button type="text" size="small" @click="DFile(scope.row)"
                  >删除</el-button
                >
                <el-button type="text" size="small" @click="yulan(scope.row)"
                  >预览</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="downloading(scope.row)"
                  >下载</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button
          style="margin-left: 10px"
          type="primary"
          @click="determine"
          v-preventReClick
          >确定</el-button
        >
        <el-button @click="dialogFormVisible = false">取消</el-button>
      </div>
      <el-dialog
        width="30%"
        title="添加资料"
        :visible.sync="innerVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        append-to-body
      >
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="资料名称">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="form.fileDesc"></el-input>
          </el-form-item>
          <el-form-item label="选择">
            <el-upload
              class="upload"
              ref="upload"
              action="string"
              :file-list="fileList"
              :auto-upload="false"
              accept=".jpg,.npg,.png,.doc,.docx,.pdf,.xlsx"
              :http-request="uploadFile"
              :on-change="handleChange"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              multiple="multiple"
            >
              <el-button
                slot="trigger"
                size="small"
                type="primary"
                @click="delFile"
                >选取文件</el-button
              >
            </el-upload>
            <span>上传文件只能是jpg,png,npg,doc,docx,pdf,xlsx格式</span>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit" v-preventReClick
              >上传</el-button
            >
            <el-button @click="innerVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-dialog>
    <!--------------------------------------------------------------------调出申请弹框--------------------------------------------------------------------------------->
    <el-dialog
      :visible.sync="dialogFormVisible1"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="设置闲置状态"
      style="width: 100% !important; margin-left: 80px"
    >
      <el-form
        :model="questionForm"
        ref="dataForm"
        label-position="left"
        label-width="100px"
        style="width: 90%; margin-left: 5%"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.dcdw">
              <el-cascader
                v-model="questionForm.dcdw"
                style="width: 100%"
                :options="options"
                :props="props1"
                :disabled="isShow1"
                clearable
                :show-all-levels="true"
                filterable
                :placeholder="lable.dcdw"
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="lable.dbly">
          <el-input
            type="textarea"
            :rows="2"
            :placeholder="'请输入' + lable.dbly"
            v-model="questionForm.dbly"
          />
        </el-form-item>
        <el-form-item label="资产列表">
          <el-table
            :data="assetsData"
            :border="true"
            style="width: 100%; text-align: center"
            size="mini"
            max-height="235px"
            :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
            :cell-style="{ textAlign: 'center' }"
          >
            <el-table-column prop="glbh" label="管理编号" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="zcbh" label="资产编号" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="zcmc" label="资产名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="id" v-if="false"> </el-table-column>
            <el-table-column prop="sbxh" label="规格型号" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="ssdw" label="所属单位" show-overflow-tooltip>
            </el-table-column>
            <el-table-column fixed="right" label="操作" show-overflow-tooltip>
              <template slot="header" slot-scope="scope">
                <DC :transferValue="transferValue" :personInfo="1"></DC>
              </template>
              <template slot-scope="scope">
                <el-button @click="handleClick(scope.row)" type="text"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          style="margin-left: 10px"
          type="primary"
          @click="determine"
          v-preventReClick
          >确定</el-button
        >
        <el-button @click="dialogFormVisible1 = false">取消</el-button>
      </div>
    </el-dialog>
    <!--------------------------------------------------------------------调入申请弹框--------------------------------------------------------------------------------->
    <el-dialog
      :visible.sync="dialogFormVisible2"
      title="调入申请"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      style="width: 100% !important; margin-left: 80px"
    >
      <el-form
        :model="questionForm"
        ref="dataForm"
        label-position="left"
        label-width="100px"
        style="width: 90%; margin-left: 5%"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.drdw">
              <el-cascader
                v-model="questionForm.drdw"
                :disabled="isShow1"
                style="width: 100%"
                :options="options"
                :props="props1"
                clearable
                :show-all-levels="true"
                filterable
                :placeholder="lable.drdw"
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="lable.dbly" prop="dbly">
          <el-input
            type="textarea"
            :rows="2"
            :placeholder="'请输入' + lable.dbly"
            v-model="questionForm.dbly"
          />
        </el-form-item>
        <el-form-item label="资产列表">
          <el-table
            :data="transfersData"
            :border="true"
            style="width: 100%"
            size="mini"
            max-height="235px"
            :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
            :cell-style="{ textAlign: 'center' }"
          >
            <el-table-column
              prop="deviceTypeName"
              label="资产分类"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column prop="id" v-if="false"></el-table-column>
            <el-table-column prop="sl" label="数量" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="lc" label="量程" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="jddj" label="精度等级" show-overflow-tooltip>
            </el-table-column>
            <el-table-column fixed="right" label="操作" show-overflow-tooltip>
              <template slot="header" slot-scope="scope">
                <el-button
                  class="flter-item"
                  type="primary"
                  @click="innerVisible1 = true"
                  >添加设备</el-button
                >
              </template>
              <template slot-scope="scope">
                <el-button @click="delDevice(scope.row)" type="text"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="附加资料">
          <el-table
            :data="fileData"
            :border="true"
            style="width: 100%; text-align: center"
            size="mini"
            max-height="235px"
            :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
            :cell-style="{ textAlign: 'center' }"
          >
            <el-table-column label="序号" type="index" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="name" label="资料名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="id" v-if="false"> </el-table-column>
            <el-table-column
              prop="createTime"
              label="上传日期"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column prop="fileDesc" label="备注" show-overflow-tooltip>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="200px">
              <template slot="header" slot-scope="scope">
                <el-button
                  type="text"
                  @click="innerVisible = true"
                  icon="el-icon-plus"
                  >增加
                </el-button>
              </template>
              <template slot-scope="scope">
                <!-- <el-button @click="handleClick(scope.row)" type="text" size="small">编辑</el-button> -->
                <el-button type="text" size="small" @click="DFile(scope.row)"
                  >删除</el-button
                >
                <el-button type="text" @click="yulan(scope.row)" size="small"
                  >预览</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="downloading(scope.row)"
                  >下载</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          style="margin-left: 10px"
          type="primary"
          @click="determine1"
          v-preventReClick
          >确定</el-button
        >
        <el-button @click="dialogFormVisible2 = false">取消</el-button>
      </div>
      <!------------------------------------------------- 添加设备弹框 -->
      <el-dialog
        width="30%"
        title="添加设备"
        :visible.sync="innerVisible1"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        append-to-body
      >
        <el-form ref="form" :model="questionForm1" label-width="80px">
          <el-form-item label="资产分类">
            <el-cascader
              v-model="questionForm1.zcfl"
              style="width: 100%"
              :options="deviceOptions"
              :props="props"
              :show-all-levels="true"
              filterable
            ></el-cascader>
          </el-form-item>
          <el-form-item label="数量">
            <el-input
              v-model="questionForm1.sl"
              oninput="value=value.replace(/[^\d]/g,'')"
            ></el-input>
          </el-form-item>
          <el-form-item label="量程">
            <el-input v-model="questionForm1.lc"></el-input>
          </el-form-item>
          <el-form-item label="精度等级">
            <el-input v-model="questionForm1.jddj"></el-input>
          </el-form-item>
          <el-form-item label="id" v-if="false">
            <el-input v-model="questionForm1.id"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="addTransferIn" v-preventReClick
              >立即添加</el-button
            >
            <el-button @click="innerVisible1 = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!-- -----------------------------------------------添加资料弹框-->
      <el-dialog
        width="30%"
        title="添加资料"
        :visible.sync="innerVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        append-to-body
      >
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="资料名称">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="form.fileDesc"></el-input>
          </el-form-item>
          <el-form-item label="选择">
            <el-upload
              class="upload"
              ref="upload"
              action="string"
              :file-list="fileList"
              :auto-upload="false"
              accept=".jpg,.npg,.png,.doc,.docx,.pdf,.xlsx"
              :http-request="uploadFile"
              :on-change="handleChange"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              multiple="multiple"
            >
              <el-button
                slot="trigger"
                size="small"
                type="primary"
                @click="delFile"
                >选取文件</el-button
              >
            </el-upload>
            <span>上传文件只能是jpg,png,npg,doc,docx,pdf,xlsx格式</span>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit" v-preventReClick
              >上传</el-button
            >
            <el-button @click="innerVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-dialog>
    <!--------------------------------------------------------------------调拨详情弹框--------------------------------------------------------------------------------->
    <el-dialog
      :visible.sync="dialogFormVisible3"
      title="调拨详情"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      style="width: 100% !important; margin-left: 100px"
    >
      <el-form
        :model="questionForm"
        ref="dataForm"
        label-position="left"
        label-width="100px"
        style="width: 90%; margin-left: 5%"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.dcdw" style="width: 90%">
              <el-input v-model="questionForm.dcdw" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.drdw">
              <el-input v-model="questionForm.drdw" :readonly="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.userName" style="width: 90%">
              <el-input v-model="questionForm.userName" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申请部门">
              <el-input v-model="questionForm.companyName" :readonly="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.sqrq" style="width: 90%">
              <el-input v-model="questionForm.sqrq" :readonly="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.statue" prop="">
              <el-input :readonly="true" v-model="questionForm.wz" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="审核结果" style="width: 90%">
              <el-input :readonly="true" v-model="inForm.shjg" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="审核意见">
              <el-input :readonly="true" v-model="inForm.shyj" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="lable.dbly" prop="dbly">
          <el-input
            type="textarea"
            :rows="2"
            :readonly="true"
            v-model="questionForm.dbly"
          />
        </el-form-item>
        <el-form-item label="资产列表" prop="correctAnswer">
          <el-table
            :data="assetsData"
            :border="true"
            style="width: 100%; text-align: center"
            size="mini"
            max-height="235px"
            :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
            :cell-style="{ textAlign: 'center' }"
          >
            <el-table-column prop="glbh" label="管理编号" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="zcbh" label="资产编号" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="zcmc" label="资产名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="sbxh" label="规格型号" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="ssdw" label="所属单位" show-overflow-tooltip>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="附加资料">
          <el-table
            :data="fileData"
            :border="true"
            style="width: 100%; text-align: center"
            size="mini"
            max-height="235px"
            :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
            :cell-style="{ textAlign: 'center' }"
          >
            <el-table-column label="序号" type="index" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="name" label="资料名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="id" v-if="false"> </el-table-column>
            <el-table-column
              prop="createTime"
              label="上传日期"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column prop="fileDesc" label="备注" show-overflow-tooltip>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="200px">
              <template slot-scope="scope">
                <el-button @click="yulan(scope.row)" type="text" size="small"
                  >预览</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="downloading(scope.row)"
                  >下载</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          style="margin-left: 10px"
          type="primary"
          @click="dialogFormVisible3 = false"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <!--------------------------------------------------------------------调入修改弹框--------------------------------------------------------------------------------->
    <el-dialog
      :visible.sync="dialogFormVisible4"
      title="调拨修改"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      style="width: 100% !important; margin-left: 100px"
    >
      <el-form
        :model="questionForm"
        ref="dataForm"
        label-position="left"
        label-width="100px"
        style="width: 90%; margin-left: 5%"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.drdw">
              <el-cascader
                v-model="questionForm.drdw"
                :disabled="isShow1"
                style="width: 100%"
                :options="options"
                :props="props1"
                clearable
                :show-all-levels="true"
                filterable
                :placeholder="'请选择' + lable.drdw"
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="lable.dbly" prop="dbly">
          <el-input
            type="textarea"
            :rows="2"
            :placeholder="'请输入' + lable.dbly"
            v-model="questionForm.dbly"
          />
        </el-form-item>
        <!-------------------------------------------设备调拨设备列表-->
        <el-form-item label="资产列表" prop="correctAnswer">
          <el-table
            :data="transfersData"
            :border="true"
            style="width: 100%"
            size="mini"
            max-height="235px"
            :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
            :cell-style="{ textAlign: 'center' }"
          >
            <el-table-column
              prop="deviceTypeName"
              label="资产分类"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column prop="id" v-if="false"></el-table-column>
            <el-table-column prop="sl" label="数量" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="lc" label="量程" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="jddj" label="精度等级" show-overflow-tooltip>
            </el-table-column>
            <el-table-column fixed="right" label="操作" show-overflow-tooltip>
              <template slot="header" slot-scope="scope">
                <el-button
                  class="flter-item"
                  type="primary"
                  @click="innerVisible1 = true"
                  >添加设备</el-button
                >
              </template>
              <template slot-scope="scope">
                <el-button @click="delDevice(scope.row)" type="text"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="附加资料">
          <el-table
            :data="fileData"
            :border="true"
            style="width: 100%; text-align: center"
            size="mini"
            max-height="235px"
            :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
            :cell-style="{ textAlign: 'center' }"
          >
            <el-table-column label="序号" type="index" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="name" label="资料名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="id" v-if="false"> </el-table-column>
            <el-table-column
              prop="createTime"
              label="上传日期"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column prop="fileDesc" label="备注" show-overflow-tooltip>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="200px">
              <template slot="header" slot-scope="scope">
                <el-button
                  type="text"
                  @click="innerVisible = true"
                  icon="el-icon-plus"
                  >增加
                </el-button>
              </template>
              <template slot-scope="scope">
                <!-- <el-button  type="text" size="small">编辑</el-button> -->
                <el-button type="text" size="small" @click="DFile(scope.row)"
                  >删除</el-button
                >
                <el-button type="text" @click="yulan(scope.row)" size="small"
                  >预览</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="downloading(scope.row)"
                  >下载</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          style="margin-left: 10px"
          type="primary"
          @click="updateAlloca"
          v-preventReClick
          >确定</el-button
        >
        <el-button @click="dialogFormVisible4 = false">取消</el-button>
      </div>
      <!------------------------------------------------- 添加设备弹框 -->
      <el-dialog
        width="30%"
        title="添加设备"
        :visible.sync="innerVisible1"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        append-to-body
      >
        <el-form ref="form" :model="questionForm1" label-width="80px">
          <el-form-item label="资产分类">
            <el-cascader
              v-model="questionForm1.zcfl"
              style="width: 100%"
              :options="deviceOptions"
              :props="props"
              :show-all-levels="true"
              filterable
            ></el-cascader>
          </el-form-item>
          <el-form-item label="数量" oninput="value=value.replace(/[^\d]/g,'')">
            <el-input v-model="questionForm1.sl"></el-input>
          </el-form-item>
          <el-form-item label="量程">
            <el-input v-model="questionForm1.lc"></el-input>
          </el-form-item>
          <el-form-item label="精度等级">
            <el-input v-model="questionForm1.jddj"></el-input>
          </el-form-item>
          <el-form-item label="id" v-if="false">
            <el-input v-model="questionForm1.id"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="addTransferIn" v-preventReClick
              >立即创建</el-button
            >
            <el-button @click="cancellation">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
      <!--------------------------------------------添加资料弹框-->
      <el-dialog
        width="30%"
        title="添加资料"
        :visible.sync="innerVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        append-to-body
      >
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="资料名称">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="form.fileDesc"></el-input>
          </el-form-item>
          <el-form-item label="选择">
            <el-upload
              class="upload"
              ref="upload"
              action="string"
              :file-list="fileList"
              :auto-upload="false"
              accept=".jpg,.npg,.png,.doc,.docx,.pdf,.xlsx"
              :http-request="uploadFile"
              :on-change="handleChange"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              multiple="multiple"
            >
              <el-button
                slot="trigger"
                size="small"
                type="primary"
                @click="delFile"
                >选取文件</el-button
              >
            </el-upload>
            <span>上传文件只能是jpg,png,npg,doc,docx,pdf,xlsx格式</span>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit" v-preventReClick
              >上传</el-button
            >
            <el-button @click="innerVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-dialog>
    <!-------------------------------------------------------------------------------------------添加调拨和调出申请修改弹框----------------------------------------------------------->
    <el-dialog
      :visible.sync="dialogFormVisible5"
      title="设备调拨"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      style="width: 100% !important; margin-left: 80px"
    >
      <el-form
        :model="questionForm"
        ref="dataForm"
        label-position="left"
        label-width="100px"
        style="width: 90%; margin-left: 5%"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.dcdw" style="width: 90%">
              <el-cascader
                v-model="questionForm.dcdw"
                style="width: 100%"
                :options="options"
                :props="props1"
                clearable
                :show-all-levels="true"
                filterable
                :placeholder="'请选择' + lable.dcdw"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.drdw" v-if="isShow3">
              <el-cascader
                v-model="questionForm.drdw"
                style="width: 100%"
                :options="options"
                :props="props1"
                clearable
                :show-all-levels="true"
                filterable
                :placeholder="'请选择' + lable.drdw"
              ></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item :label="lable.dbly" prop="dbly">
          <el-input
            type="textarea"
            :rows="2"
            :placeholder="'请输入' + lable.dbly"
            v-model="questionForm.dbly"
          />
        </el-form-item>
        <el-form-item label="资产列表">
          <el-table
            :data="assetsData"
            :border="true"
            style="width: 100%; text-align: center"
            size="mini"
            max-height="235px"
            :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
            :cell-style="{ textAlign: 'center' }"
          >
            <el-table-column prop="glbh" label="管理编号" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="zcbh" label="资产编号" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="zcmc" label="资产名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="sbxh" label="规格型号" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="ssdw" label="所属单位" show-overflow-tooltip>
            </el-table-column>
            <el-table-column fixed="right" label="操作" show-overflow-tooltip>
              <template slot="header" slot-scope="scope">
                <DC
                  :form="form"
                  :transferValue="transferValue"
                  :personInfo="1"
                ></DC>
              </template>
              <template slot-scope="scope">
                <el-button @click="handleClick(scope.row)" type="text"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="附加资料" prop="dbly" max-height="235px">
          <el-table
            :data="fileData"
            :border="true"
            style="width: 100%; text-align: center"
            size="mini"
            :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
            :cell-style="{ textAlign: 'center' }"
          >
            <el-table-column label="序号" type="index" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="name" label="资料名称" show-overflow-tooltip>
            </el-table-column>
            <el-table-column
              prop="createTime"
              label="上传日期"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column prop="fileDesc" label="备注" show-overflow-tooltip>
            </el-table-column>
            <el-table-column fixed="right" label="操作" width="200px">
              <template slot="header" slot-scope="scope">
                <el-button
                  type="text"
                  @click="innerVisible = true"
                  icon="el-icon-plus"
                  >增加
                </el-button>
              </template>
              <template slot-scope="scope">
                <!-- <el-button  size="small">编辑</el-button> -->
                <el-button @click="DFile(scope.row)" type="text" size="small"
                  >删除</el-button
                >
                <el-button type="text" size="small" @click="yulan(scope.row)"
                  >预览</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="downloading(scope.row)"
                  >下载</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          style="margin-left: 10px"
          type="primary"
          @click="updateAlloca1"
          v-preventReClick
          >确定</el-button
        >
        <el-button @click="dialogFormVisible5 = false">取消</el-button>
      </div>
      <el-dialog
        width="30%"
        title="添加资料"
        :visible.sync="innerVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        append-to-body
      >
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="资料名称">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="form.fileDesc"></el-input>
          </el-form-item>
          <el-form-item label="选择">
            <el-upload
              class="upload"
              ref="upload"
              action="string"
              :file-list="fileList"
              :auto-upload="false"
              accept=".jpg,.npg,.png,.doc,.docx,.pdf,.xlsx"
              :http-request="uploadFile"
              :on-change="handleChange"
              :on-preview="handlePreview"
              :on-remove="handleRemove"
              multiple="multiple"
            >
              <el-button
                slot="trigger"
                size="small"
                type="primary"
                @click="delFile"
                >选取文件</el-button
              >
            </el-upload>
            <span>上传文件只能是jpg,png,npg,doc,docx,pdf,xlsx格式</span>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit" v-preventReClick
              >上传</el-button
            >
            <el-button @click="innerVisible = false">取消</el-button>
          </el-form-item>
        </el-form>
      </el-dialog>
    </el-dialog>
    <!------------------------------------------------------------------------------调入详情----------------------------------------------------------------------->
    <el-dialog
      :visible.sync="dialogFormVisible7"
      title="调入申请详情"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      style="width: 110% !important"
    >
      <el-form
        :model="inForm"
        ref="dataForm"
        label-position="left"
        label-width="100px"
        style="width: 100%"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.id" style="width: 90%">
              <el-input :readonly="true" v-model="inForm.id" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.drdw">
              <el-input :readonly="true" v-model="inForm.drdw" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.userName" style="width: 90%">
              <el-input :readonly="true" v-model="inForm.userName" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="申请部门">
              <el-input :readonly="true" v-model="inForm.companyName" />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item :label="lable.sqrq" style="width: 90%">
              <el-input :readonly="true" v-model="inForm.sqrq" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="lable.dbly" prop="dbly">
              <el-input :readonly="true" v-model="inForm.dbly" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="审核结果" style="width: 90%">
              <el-input :readonly="true" v-model="inForm.shjg" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="审核意见">
              <el-input :readonly="true" v-model="inForm.shyj" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="需求列表">
              <el-table
                :data="transfersData"
                :border="true"
                style="width: 90%"
                size="mini"
                max-height="235px"
                :header-cell-style="{
                  textAlign: 'center',
                  background: '#eff3f6',
                }"
                :cell-style="{ textAlign: 'center' }"
              >
                <el-table-column
                  prop="deviceTypeName"
                  label="资产分类"
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column prop="id" v-if="false"></el-table-column>
                <el-table-column
                  prop="sl"
                  label="数量"
                  width="50"
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                  prop="lc"
                  label="量程"
                  width="50"
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                  prop="jddj"
                  label="精度等级"
                  width="70"
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                  prop="dbsl"
                  label="已调拨数量"
                  show-overflow-tooltip
                >
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="资产列表">
              <el-table
                :data="assetsAllData"
                :border="true"
                style="width: 100%; text-align: center"
                size="mini"
                max-height="235px"
                :header-cell-style="{
                  textAlign: 'center',
                  background: '#eff3f6',
                }"
                :cell-style="{ textAlign: 'center' }"
              >
                <el-table-column
                  prop="glbh"
                  label="管理编号"
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                  prop="zcbh"
                  label="资产编号"
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                  prop="zcmc"
                  label="资产名称"
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column prop="id" v-if="false"> </el-table-column>
                <el-table-column
                  prop="sbxh"
                  label="规格型号"
                  show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                  prop="ssdw"
                  label="所属单位"
                  show-overflow-tooltip
                >
                </el-table-column>
              </el-table>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="调拨列表">
          <el-table
            :data="allData"
            :border="true"
            style="width: 100%; text-align: center"
            size="mini"
            max-height="235px"
            :header-cell-style="{ textAlign: 'center', background: '#eff3f6' }"
            :cell-style="{ textAlign: 'center' }"
          >
            <el-table-column prop="id" label="调拨id" show-overflow-tooltip>
            </el-table-column>
            <el-table-column
              prop="dcdw"
              label="调出试验室"
              show-overflow-tooltip
            >
            </el-table-column>
            <el-table-column prop="shjg" label="审核结果" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="shyj" label="审核意见" show-overflow-tooltip>
            </el-table-column>
            <el-table-column
              prop="statue"
              label="调拨状态"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <span v-if="scope.row.statue == '4'" style="color: #4095e5"
                  >待审核</span
                >
                <span
                  v-else-if="scope.row.statue == '2'"
                  style="color: rgb(204, 169, 13)"
                  >撤回</span
                >
                <span v-else-if="scope.row.statue == '5'" style="color: coral"
                  >待调拨</span
                >
                <span v-else-if="scope.row.statue == '7'" style="color: gray"
                  >待调出确认</span
                >
                <span v-else-if="scope.row.statue == '8'" style="color: gray"
                  >待调入确认</span
                >
                <span
                  v-else-if="scope.row.statue == '9'"
                  style="color: yellowgreen"
                  >调拨完成</span
                >
                <span v-else-if="scope.row.statue == '0'" style="color: red"
                  >驳回</span
                >
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="操作" show-overflow-tooltip>
              <template slot-scope="scope">
                <el-button
                  @click="selectClick(scope.row)"
                  type="primary"
                  size="small"
                  >详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible7 = false">确定</el-button>
      </div>
    </el-dialog>
    <!-- 添加显示购物车按钮，如果复选框有选中让显示，否则不显示 -->
    <div
      style="
        position: fixed;
        top: 12%;
        left: 29%;
        height: 50px;
        width: 50px;
        color: #4095e5;
        font-size: 20px;
      "
      @click="checkBoxdialog = true"
      v-if="checkBoxData.length > 0"
    >
      <!-- <i class="iconfont icon-icon-test" style="width:100%;height:100%;font-size: 40px;"></i> -->
      <el-badge :value="checkBoxNumber">
        <img
          src="../../../static/img/selects.png"
          style="width: 70%; height: 70%; font-size: 40px"
        />
        <!-- <span class="iconfont icon-icon-test" style="width:100%;height:100%;font-size: 40px;"></span> -->
      </el-badge>
    </div>
    <!-- 显示购物车列表 -->
    <el-dialog
      title="已选择设备"
      :visible.sync="checkBoxdialog"
      append-to-body
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-button
        type="primary"
        size="mini"
        @click="removeAllCheckbox"
        style="margin-top: -30px; float: left"
        >清空内容</el-button
      >
      <el-table
        :data="checkBoxData"
        v-if="checkBoxNumber > 0"
        :header-cell-style="{ background: '#eff3f6' }"
        style="padding-top: 5px"
      >
        <el-table-column
          type="index"
          label="序号"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column prop="id" :label="lable.id" width="170">
          <template slot-scope="scope" show-overflow-tooltip>
            <el-link
              :underline="false"
              @click="selectClick(scope.row)"
              style="color: #4095e5; text-decoration: none"
            >
              {{ scope.row.id }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column
          prop="sqrq"
          :formatter="formateTime"
          :label="lable.sqrq"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column prop="drdw" :label="lable.drdw" show-overflow-tooltip>
        </el-table-column>
        <el-table-column prop="dcdw" :label="lable.dcdw" show-overflow-tooltip>
        </el-table-column>
        <el-table-column
          prop="userName"
          :label="lable.userName"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column prop="dbly" :label="lable.dbly" show-overflow-tooltip>
        </el-table-column>

        <el-table-column
          prop="statue"
          :label="lable.statue"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            <span v-if="scope.row.statue == '4'" style="color: #4095e5"
              >待审核</span
            >
            <span
              v-else-if="scope.row.statue == '2'"
              style="color: rgb(204, 169, 13)"
              >撤回</span
            >
            <span
              v-else-if="scope.row.statue == '6'"
              style="color: mediumturquoise"
              >待确认</span
            >
            <span v-else-if="scope.row.statue == '5'" style="color: coral"
              >待调拨</span
            >
            <span v-else-if="scope.row.statue == '7'" style="color: gray"
              >待调出确认</span
            >
            <span v-else-if="scope.row.statue == '8'" style="color: gray"
              >待调入确认</span
            >
            <span v-else-if="scope.row.statue == '9'" style="color: yellowgreen"
              >调拨完成</span
            >
            <span v-else-if="scope.row.statue == '0'" style="color: red"
              >驳回</span
            >
          </template>
        </el-table-column>
        <el-table-column label="操作" style="text-decoration: none">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="small"
              @click="removeThisData(scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog
      :title="previewTitle"
      :visible.sync="docxdialog"
      style="margin-top: -50px"
      width="63%"
    >
      <FilePreview ref="filePreview" />
    </el-dialog>
  </div>
</template>
<script>
import {
  findAllAllocation,
  findByUserIdCompanyTree,
  findByIdFile,
  delByIdFile,
  upload,
  addAllocation,
  findByIdAllocation,
  findByIdDevice,
  delByIdDevice,
  selectTreeDeviceType,
  findTransferIn,
  updateAllocation,
  selectAllstatus,
  selectByPid,
  selectAllDevice,
  findByIdTypeName,
  submitBatchId,
  findByCode,
  findByModule,
  wordAllExport,
  withdrawAllocation,
  applyWithdraw,
} from "../../api/api";
import FilePreview from "../../components/preview/FilePreview.vue";
import AllocationMultiple from "../../components/common/AllocationMultiple.vue";
export default {
  name: "Allocation",
  components: {
    FilePreview: FilePreview,
    DC: AllocationMultiple,
  },
  data() {
    return {
      show: {
        drsq: false,
        dcsq: false,
        sbdb: false,
        xg: false,
        sc: false,
        xzdb: false,
        dctz: false,
        ch: false,
      },
      checkBoxdialog: false,
      checkBoxData: [],
      checkBoxNumber: 0,
      props: {
        label: "deviceTypeName",
        value: "id",
        children: "deviceTypes",
        expandTrigger: "click",
        emitPath: false,
      },
      // companyProps:{
      //   label: "companyName",
      //   value: "companyName",
      //   children: "zcompany",
      //   expandTrigger: "click",
      //   emitPath: false,
      // },
      props1: {
        label: "companyName",
        value: "companyName",
        children: "zcompany",
        emitPath: false,
        checkStrictly: true,
      },
      companyProps: {
        label: "companyName",
        value: "companyCode",
        children: "zcompany",
        emitPath: false,
        checkStrictly: true,
      },
      deviceInfo: {
        date: [],
        content: "",
        state: "",
        transferIn: "",
        transferOut: "",
      },
      total: 0,
      pageIndex: 1,
      pagesize: 10,
      data: [],
      transfersData: [],
      allocationData: [],
      assetsData: [],
      dialogFormVisible: false,
      dialogFormVisible1: false,
      dialogFormVisible2: false,
      dialogFormVisible3: false,
      dialogFormVisible4: false,
      dialogFormVisible5: false,
      dialogFormVisible6: false,
      dialogFormVisible7: false,
      parame: {
        state: 4,
        companyCode: JSON.parse(localStorage.getItem("user")).companyCode,
      },
      options: [],
      options3: [],
      deviceOptions: [],
      questionForm: {
        transferId: [],
        deviceId: [],
        dblx: "",
      },
      inForm: {},
      isShow3: false,
      isShow1: true,
      isShow: false,
      transfers: [],
      innerVisible: false,
      innerVisible1: false,
      form: {
        name: "",
        fileDesc: "",
      },
      docxdialog: false,
      previewTitle: "",
      fileData: [],
      fileList: [],
      lable: {},
      questionForm1: {},
      allData: [],
      assetsAllData: [],
      userinfo: {},
    };
  },
  methods: {
    getRowKeys(row) {
      return row.id;
    },
    //清空所有内容
    removeAllCheckbox() {
      this.checkBoxData = [];
      this.checkBoxNumber = this.checkBoxData.length;
      this.$refs.allocationData.clearSelection(); //清除所有选中复选框
      this.checkBoxdialog = false;
    },
    //获取复选框选中数据
    changeCheckBoxValue(val) {
      this.checkBoxData = val;
      this.checkBoxNumber = this.checkBoxData.length;
    },
    //移除一条选中内容
    removeThisData(row) {
      let newCheckBoxData = [];
      for (var i = 0; i < this.checkBoxData.length; i++) {
        if (this.checkBoxData[i].id != row.id) {
          // debugger
          newCheckBoxData.push(this.checkBoxData[i]);
        }
      }
      this.checkBoxData = newCheckBoxData;
      if (this.checkBoxData.length > 0) {
        this.$refs.allocationData.store.states.selection.map((item, index) => {
          if (item.id === row.id) {
            this.$refs.allocationData.store.states.selection.splice(index, 1);
          }
        });
      } else {
        this.$refs.allocationData.clearSelection(); //清除所有选中复选框
        this.checkBoxdialog = false;
      }
      this.checkBoxNumber = this.checkBoxData.length;
    },
    clickApplyWithdraw(row) {
      this.$confirm("此操作将撤回该条申请, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        var userinfo = JSON.parse(localStorage.getItem("user"));
        var map = {
          id: row.id,
          userId: userinfo.userId,
        };
        applyWithdraw(map).then((datas) => {
          // debugger
          let { status, message } = datas;

          if (status == 200) {
            this.$message({
              message: "撤回成功",
              type: "success",
            });
            this.findAll();
          } else {
            this.$message({
              message: message,
              type: "error",
            });
          }
        });
      });
    },

    //调拨撤回
    withdrawClick(row) {
      this.$confirm("此操作将撤回该条申请, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        var userinfo = JSON.parse(localStorage.getItem("user"));
        var map = {
          id: row.id,
          userId: userinfo.userId,
        };
        withdrawAllocation(map).then((datas) => {
          // debugger
          let { status, message } = datas;
          if (status == 400) {
            this.$message({
              message: message,
              type: "error",
            });
          } else if (status == 200) {
            this.$message({
              message: "撤回成功",
              type: "success",
            });
            this.findAll();
            // if (row.allPid != null) {
            //   this.findTransfer(row.allPid)
            //   this.selectAll1(row.allPid);
            //   this.selectAllDvice(row.allPid);
            // }
          }
        });
      });
    },

    // 格式化时间显示到日期
    formateTime(row) {
      let nowData = new Date(row.sqrq);
      let year = nowData.getFullYear();
      let month = (nowData.getMonth() + 1).toString().padStart(2, "0");
      let date = nowData.getDate().toString().padStart(2, "0");
      return `${year}-${month}-${date}`;
    },
    downloading(scop) {
      // debugger
      this.downloadUtil.downloadFile(scop.path, scop.name);
    },
    //确认完成
    qrwc() {
      var userinfo = JSON.parse(localStorage.getItem("user"));
      var map = {
        id: this.inForm.id,
        userId: userinfo.userId,
      };
      submitBatchId(map).then((datas) => {
        // debugger
        let { status, message } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error",
          });
        } else if (status == 200) {
          this.$message({
            message: "调拨完成",
            type: "success",
          });
          this.findAll();
        }
      });
    },
    //预览
    yulan(row) {
      if (
        row.path.substring(row.path.lastIndexOf(".") + 1) == "jpg" ||
        row.path.substring(row.path.lastIndexOf(".") + 1) == "png" ||
        row.path.substring(row.path.lastIndexOf(".") + 1) == "jpeg"
      ) {
        this.previewTitle = "图片预览";
      } else {
        this.previewTitle = "文件预览";
      }
      this.docxdialog = true;
      this.$nextTick(() => {
        this.$refs.filePreview.showView(row.path);
      });
    },
    //选择页面跳转
    qudb() {
      this.questionForm = {};
      this.handleCreate();
      this.questionForm.pid = this.inForm.id;
      this.questionForm.drdw = this.inForm.drdw;
      this.questionForm.dbly = this.inForm.dbly;
    },
    //导出
    derive() {
      this.loadingUtil.showLoading("正在下载中，请稍后……");
      let _this = this;
      var userinfo = JSON.parse(localStorage.getItem("user"));
      let map = {
        start: this.deviceInfo.date == null ? null : this.deviceInfo.date[0],
        end: this.deviceInfo.date == null ? null : this.deviceInfo.date[1],
        transferIn: this.deviceInfo.transferIn,
        transferOut: this.deviceInfo.transferOut,
        content: this.deviceInfo.content,
        state: this.deviceInfo.state,
        userId: userinfo.userId,
      };
      if (this.checkBoxData.length > 0) {
        map["ids"] = this.checkBoxData.map((item) => item.id).join();
      } else {
        map["ids"] = "";
      }
      wordAllExport(map).then((datas) => {
        const blob = new Blob([datas]);
        const dlink = document.createElement("a");
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const dlink = document.createElement("a");
          dlink.download = "调拨文件.zip";
          dlink.style.display = "none";
          dlink.href = URL.createObjectURL(blob);
          document.body.appendChild(dlink);
          dlink.click();
          URL.revokeObjectURL(dlink.href); // 释放URL 对象
          document.body.removeChild(dlink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, "维保台账.xlsx");
        }
      });
      this.loadingUtil.hideLoading();
    },
    //选择设备弹框
    transferValue(outData) {
      for (var i = 0; i < outData.length; i++) {
        this.assetsData.push(outData[i]);
      }
    },
    selectAllDvice(row) {
      var userinfo = JSON.parse(localStorage.getItem("user"));
      var map = {
        id: row,
        userId: userinfo.userId,
      };
      selectAllDevice(row).then((datas) => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          this.assetsAllData = [];
          this.assetsAllData = data;
        }
      });
    },
    selectAll1(row) {
      var userinfo = JSON.parse(localStorage.getItem("user"));
      var map = {
        id: row,
        userId: userinfo.userId,
      };
      selectByPid(map).then((datas) => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          this.allData = [];
          this.allData = data;
        }
      });
    },
    //打开详情弹框
    selectClick(row) {
      if (row.dblx == 2) {
        this.dialogFormVisible7 = true;
        this.findTransfer(row.id);
        this.inForm = {};
        this.inForm = row;
        this.selectAll1(row.id);
        this.selectAllDvice(row.id);
        //查找子调拨设备信息
      } else {
        this.inForm = {};
        this.dialogFormVisible3 = true;
        this.findByIdfile(row.id);
        this.findByDevice(row.id);
        this.findById(row.id);
      }
    },
    //打开调拨更新弹框 并设置内容
    updateClick(row) {
      if (row.dblx == 2) {
        this.findTransfer(row.id);
        this.findByIdfile(row.id);
        this.findById(row.id);
        this.dialogFormVisible4 = true;
      } else {
        if (row.dblx == 1) {
          this.isShow3 = false;
        } else {
          this.isShow3 = true;
        }
        this.dialogFormVisible5 = true;
        this.findByIdfile(row.id);
        this.findByDevice(row.id);
        this.findById(row.id);
      }
    },
    //删除调拨
    delAllocation(row) {
      this.$confirm("此操作将永久删除该条信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        var userinfo = JSON.parse(localStorage.getItem("user"));
        var map = {
          id: row.id,
          userId: userinfo.userId,
        };
        delByIdDevice(map).then((datas) => {
          // debugger
          let { status, message } = datas;
          if (status == 400) {
            this.$message({
              message: message,
              type: "error",
            });
          } else if (status == 200) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.findAll();
            if (row.allPid != null) {
              this.findTransfer(row.allPid);
              this.selectAll1(row.allPid);
              this.selectAllDvice(row.allPid);
            }
          }
        });
      });
    },
    //删除调入设备绑定
    delDevice(row) {
      this.transfersData.splice(this.transfersData.indexOf(row), 1);
    },
    //根据单号查询调拨设备
    findByDevice(row) {
      findByIdDevice(row).then((datas) => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          this.assetsData = data;
        }
      });
    },

    //根据id调拨详情
    findById(row) {
      findByIdAllocation(row).then((datas) => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          // this.questionForm={}
          this.questionForm = data;
        }
      });
    },
    //移除调拨资产
    handleClick(row) {
      this.assetsData.splice(this.assetsData.indexOf(row), 1);
    },
    //打开设备调拨弹框
    handleCreate() {
      this.questionForm = {
        deviceId: [],
        transferId: [],
      };
      let id = "db" + +new Date();
      this.questionForm.id = id;
      this.questionForm.dblx = 0;
      this.fileData = [];
      this.assetsData = [];
      this.dialogFormVisible = true;
    },
    //打开调出申请弹框
    handleCreate1() {
      let id = "db" + +new Date();
      this.dialogFormVisible1 = true;
      (this.questionForm = {}), (this.assetsData = []);
      this.questionForm.dblx = 1;
      this.questionForm.id = id;
      this.fileData = [];
      // var userinfo = JSON.parse(localStorage.getItem("user"))
      findByCode(userinfo.companyCode).then((datas) => {
        // debugger
        let { status, data } = datas;
        if (data == null) {
          this.$message.warning("单位信息已失效，请联系管理员");
        }
        if (status == 200) {
          this.$set(this.questionForm, `dcdw`, data);
        }
      });
    },
    //打开调入申请弹框并设置内容
    handleCreate2() {
      let id = "db" + +new Date();
      this.dialogFormVisible2 = true;
      var userinfo = JSON.parse(localStorage.getItem("user"));
      this.questionForm = {
        deviceId: [],
        transferId: [],
      };
      findByCode(userinfo.companyCode).then((datas) => {
        // debugger
        let { status, data } = datas;
        if (status == 200) {
          if (data == null) {
            this.$message.warning("单位信息已失效，请联系管理员");
          }
          this.$set(this.questionForm, `drdw`, data);
          this.questionForm.dblx = 2;
          this.questionForm.id = id;
          this.transfersData = [];
          this.fileData = [];
        }
      });
    },
    //添加设备调拨信息
    determine() {
      var m = [];
      for (let i = 0; i < this.assetsData.length; i++) {
        var a = this.assetsData[i];
        m.push(a.id);
      }
      var userinfo = JSON.parse(localStorage.getItem("user"));
      this.questionForm.sqr = userinfo.userId;
      this.questionForm.deviceId = m;
      addAllocation(this.questionForm).then((datas) => {
        // debugger
        let { status, message } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error",
          });
        } else if (status == 200) {
          this.dialogFormVisible = false;
          this.dialogFormVisible1 = false;
          this.findAll();
          this.$message({
            message: "添加成功",
            type: "success",
          });
          //判断是否有父级单号 进行页面切换
          if (this.questionForm.pid != null) {
            var id = this.questionForm.pid;
            this.dialogFormVisible6 = true;
            this.selectAll1(id);
            this.selectAllDvice(id);
            this.findTransfer(id);
          }
        }
      });
    },
    cancellation() {
      this.innerVisible1 = false;
      this.questionForm1 = {};
    },
    //添加调入申请
    determine1() {
      if (this.transfersData.length== 0) {
        this.$message.warning("请选择调入设备");
      } else {
        for (let is = 0; is < this.transfersData.length; is++) { 
          var a = this.transfersData[is];
          this.questionForm.transferId.push(a);
        }
        var userinfo = JSON.parse(localStorage.getItem("user"));
        this.questionForm.sqr = userinfo.userId;
        console.log(this.questionForm)
        addAllocation(this.questionForm).then((datas) => {
          // debugger
          let { status, message } = datas;
          if (status == 400) {
            this.$message({
              message: message,
              type: "error",
            });
          } else if (status == 200) {
            this.dialogFormVisible2 = false;
            this.findAll();
            this.transfersData = [];
            this.questionForm = {
              deviceId: [],
              transferId: [],
            };
            this.$message({
              message: "添加成功",
              type: "success",
            });
          } else {
            this.$message({
              message: "请求错误",
              type: "error",
            });
          }
        });
      }
    },
    //删除检定附件信息
    DFile(row) {
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        delByIdFile(row.id).then((datas) => {
          // debugger
          let { status, message } = datas;
          if (status == 400) {
            this.$message({
              message: message,
              type: "error",
            });
          } else if (status == 200) {
            this.findByIdfile(this.questionForm.id);
            this.$message({
              message: message,
              type: "success",
            });
          } else {
            this.$message({
              message: "请求错误",
              type: "error",
            });
          }
        });
      });
    },
    //根据id查找文件
    findByIdfile(id) {
      findByIdFile(id).then((datas) => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          this.fileData = data;
        }
      });
    },
    //点击上传文件触发的额外事件,清空fileList
    delFile() {
      this.fileList = [];
    },
    handleChange(file, fileList) {
      this.fileList = fileList;
    },
    //自定义上传文件
    uploadFile(file) {
      this.formData.append("file", file.file);
    },
    //删除文件
    handleRemove(file, fileList) {},
    // 点击文件
    handlePreview(file) {},
    //文件上传
    onSubmit() {
      if (this.fileList[0] == null) {
        this.$message.error("请选择上传的文件"); // .....失败信息
      } else {
        var formData = new FormData();
        formData.append("file", this.fileList[0].raw); //拿到存在fileList的文件存放到formData中
        //下面数据是我自己设置的数据,可自行添加数据到formData(使用键值对方式存储)
        formData.append("name", this.form.name);
        formData.append("fileDesc", this.form.fileDesc);
        formData.append("number", this.questionForm.id);
        var userinfo = JSON.parse(localStorage.getItem("user"));

        formData.append("userId", userinfo.userId);
        upload(formData).then((datas) => {
          // debugger
          let { status, message, data } = datas;
          if (status == 400) {
            this.$message({
              message: message,
              type: "error",
            });
          } else if (status == 200) {
            this.fileData.push(data);
            // this.findByIdfile(id);
            this.$message({
              message: "上传成功",
              type: "success",
            });
          } else {
            this.$message({
              message: "请求错误",
              type: "error",
            });
          }
          this.form.fileDesc = "";
          this.form.name = "";
          this.fileList = [];
          this.innerVisible = false;
        });
      }
    },
    //添加调入资产
    addTransferIn() {
      findByIdTypeName(this.questionForm1.zcfl).then((datas) => {
        // debugger
        let { status, message, data } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error",
          });
        } else if (status == 200) {
          this.questionForm1.deviceTypeName = data;
          this.transfersData.push(this.questionForm1);
          this.innerVisible1 = false;
          this.questionForm1 = {
            deviceId: [],
            transferId: [],
          };
        }
      });
    },
    //根据id查找申请调入设备信息
    findTransfer(id) {
      findTransferIn(id).then((datas) => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          this.transfersData = data;
        }
      });
    },
    //更新调调拨调出信息
    updateAlloca1() {
      var a = [];
      for (let q = 0; q < this.assetsData.length; q++) {
        var m = this.assetsData[q].id;
        a.push(m);
      }
      var a1 = [];
      for (let i = 0; i < this.fileData.length; i++) {
        var a2 = this.fileData[i];
        a1.push(a2.id);
      }
      this.questionForm.fileIds = a1;
      this.questionForm.deviceId = a;
      var userinfo = JSON.parse(localStorage.getItem("user"));
      this.questionForm.userId = userinfo.userId;
      updateAllocation(this.questionForm).then((datas) => {
        // debugger
        let { status, message } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error",
          });
        } else if (status == 200) {
          this.dialogFormVisible5 = false;
          this.findAll();
          this.questionForm = {
            deviceId: [],
            transferId: [],
          };
          this.$message({
            message: "更细成功",
            type: "success",
          });
        } else {
          this.$message({
            message: "请求错误",
            type: "error",
          });
        }
      });
    },
    //更新调入申请信息
    updateAlloca() {
      var a1 = [];
      for (let i = 0; i < this.fileData.length; i++) {
        var a = this.fileData[i];
        a1.push(a.id);
      }
      this.questionForm.fileIds = a1;
      this.questionForm.transferId = this.transfersData;
      var userinfo = JSON.parse(localStorage.getItem("user"));
      this.questionForm.userId = userinfo.userId;
      updateAllocation(this.questionForm).then((datas) => {
        // debugger
        let { status, message } = datas;
        if (status == 400) {
          this.$message({
            message: message,
            type: "error",
          });
        } else if (status == 200) {
          this.dialogFormVisible4 = false;
          this.findAll();
          this.transfersData = [];
          this.questionForm = {
            deviceId: [],
            transferId: [],
          };
          this.$message({
            message: "编辑成功",
            type: "success",
          });
        } else {
          this.$message({
            message: "请求错误",
            type: "error",
          });
        }
      });
    },
    getTreeData1(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].zcompany.length < 1) {
          // 最后一级没有数据将children变成undefined
          data[i].zcompany = undefined;
        } else {
          // children不为空时继续调用该方法
          this.getTreeData1(data[i].zcompany);
        }
      }
      return data;
    },
    //查询所有单位
    // selectCompany() {
    //   treeCompany().then((datas) => {
    //     let { status, message, data } = datas;
    //     if (status == 200) {
    //       this.options = this.getTreeData1(data);
    //     }
    //   });
    // },
    getTreeData(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].deviceTypes.length < 1) {
          // 最后一级没有数据将children变成undefined
          data[i].deviceTypes = undefined;
        } else {
          // children不为空时继续调用该方法
          this.getTreeData(data[i].deviceTypes);
        }
      }
      return data;
    },
    findAllClick() {
      this.pageIndex = 1;
      this.findAll();
    },
    //查找所有调拨信息
    findAll() {
      var userinfo = JSON.parse(localStorage.getItem("user"));
      let map = {
        start: this.deviceInfo.date == null ? null : this.deviceInfo.date[0],
        end: this.deviceInfo.date == null ? null : this.deviceInfo.date[1],
        transferIn: null,
        transferOut: null,
        content: this.deviceInfo.content,
        state: this.deviceInfo.state,
        userId: userinfo.userId,
      };
      findAllAllocation(map).then((datas) => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          if (data == null) {
            this.data = [];
          } else {
            this.data = data;
          }
          this.allocationData = this.data.slice(
            (this.pageIndex - 1) * this.pagesize,
            this.pageIndex * this.pagesize
          );
          this.total = this.data.length;
        }
      });
    },
    getTreeData(data) {
      for (let i = 0; i < data.length; i++) {
        if (data[i].deviceTypes.length < 1) {
          // 最后一级没有数据将children变成undefined
          data[i].deviceTypes = undefined;
        } else {
          // children不为空时继续调用该方法
          this.getTreeData(data[i].deviceTypes);
        }
      }
      return data;
    },
    //查找所有资产分类
    selectDeviceType() {
      selectTreeDeviceType().then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.deviceOptions = this.getTreeData(data);
        }
      });
    },
    //查询所有状态
    findAllType() {
      selectAllstatus().then((datas) => {
        // debugger
        let { status, message, data } = datas;
        if (status == 200) {
          for (var i = 0; i < data.length; i++) {
            if (data[i].statusType == "调拨管理") {
              this.options3.push({
                name: data[i].statusName,
                id: data[i].statue,
              });
            }
          }
        }
      });
    },
    //分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      //contentdata是所有的数据，是一个大数组。使用.slice()方法可以将大数组切分
      //.slice()方法接受两个参数，开始和结束的值
      //这样得到的currentdata就是固定只有10个值的数组了，就可以用v-for展示啦
      this.allocationData = this.data.slice(
        (this.pageIndex - 1) * this.pagesize,
        this.pageIndex * this.pagesize
      );
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.allocationData = this.data.slice(
        (this.pageIndex - 1) * this.pagesize,
        this.pageIndex * this.pagesize
      );
    },
    isFromDeviceDetail() {
      let row = JSON.parse(sessionStorage.getItem("allocationData"));
      if (row != null) {
        this.selectClick(row);
        sessionStorage.removeItem("allocationData");
      }
    },
    findLable() {
      findByModule("调拨管理").then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.lable = data;
        }
      });
    },

    getCompanyTree() {
      var userinfo = JSON.parse(localStorage.getItem("user"));
      var companyCode = "-1";
      if (
        userinfo.userRole == 1 ||
        (userinfo.fjqx != null &&
          (userinfo.fjqx.indexOf("3") != -1 ||
            userinfo.fjqx.indexOf("4") != -1))
      ) {
        companyCode = "-1";
      } else {
        companyCode = userinfo.companyCode;
      }
      if (userinfo.companyCode == "G065") {
        companyCode = "-1";
      }
      findByUserIdCompanyTree(companyCode).then((datas) => {
        let { status, message, data } = datas;
        if (status == 200) {
          this.options = this.getTreeData1(data);
        }
      });
    },
  },
  created() {
    this.findLable();
    this.findAll();
    this.selectDeviceType();

    this.getCompanyTree();
    this.findAllType();
    this.isFromDeviceDetail();
    var userinfo = JSON.parse(localStorage.getItem("user"));
    this.userinfo = userinfo;
    var arr = userinfo.role.menuId.split(",");
    arr.forEach((i) => {
      if (i == "77") {
        this.show.drsq = true;
      }
      if (i == "78") {
        this.show.dcsq = true;
      }
      if (i == "79") {
        this.show.sbdb = true;
      }
      if (i == "80") {
        this.show.xg = true;
      }
      if (i == "81") {
        this.show.sc = true;
      }
      if (i == "82") {
        this.show.xzdb = true;
      }
      if (i == "83") {
        this.show.dctz = true;
      }
      if (i == "199") {
        this.show.ch = true;
      }
      if (i == "202") {
        this.show.dbch = true;
      }
    });
    if (
      userinfo.userRole == 1 ||
      (userinfo.companyCode != null && userinfo.companyCode == "G065")
    ) {
      this.isShow1 = false;
    }
  },
  // keep-alive 缓存后重新激活时，保留搜索条件刷新列表
  activated() {
    this.findAll();
  },
};
</script>
<style >
.el-checkbox__inner {
  border: 1px solid #606266 !important;
}
</style>
<style scoped>
.btn {
  float: left;
  margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/allocation/Allocation.vue